import { Link } from 'gatsby'
import { Button } from 'nzk-react-components'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`

const Wrapper = styled.div`
  color: #351778;
  margin: 50px 0;
  h2,h3 {
    font-weight: bold;
    text-align: center;
  }

  .title {
    position: relative;
    width: fit-content;
    margin: 0 auto;
    padding-top: 10px;
    img {
      position: absolute;
      top: 50px;
      right: 0;
      transform: translate(100%, -100%);
    }

  }

  .quotes {
    padding: 12px 0 10px 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .quotes--track,
  .quotes--group {
    display: flex;
    width: max-content;
    gap: 2em;
  }

  .quotes--group {
    gap: 2em;
    padding-right: 2em;
  }

  .quote {
    display: flex;
    background: #fff;
    border-radius: .8em;
    box-shadow: 0 0 12px rgba(0,0,0,0.2);
    width: 350px;
    padding: 1.6em 1.8em;
    flex-direction: column;
    gap: 1em;
    .quote--rating {
      height: 20px;
      img {
        height: 100%;
      }
    }
    .quote--text {
      font-weight: bold;
    }
    .quote--author {
      > :first-child {
        font-weight: bold;
      }
    }
  }

.cta {
    text-align:center;
  margin-top: 60px;
}

  @media screen and (max-width: 1179px) {
    .title {
      max-width: 220px;
    }

    .quotes {
      justify-content: flex-start;
      overflow: hidden;
      flex-wrap: nowrap;

      &:hover .quotes--track {
        animation-play-state: paused;
      }
    }

    .quotes--track {
      animation: ${scroll} 20s linear infinite;
    }

    .quote {
      flex: 0 0 350px;
    }
  }

`

export const ParentsV2_RatingsHero = (props: {
  title: string
  quotes: {
    text: string
    author: { name: string, type: string }
  }[]
  cta?: {
    label: string
    url: string
  }
}) => {
  return <Wrapper>
    <div className='title'>
      <h2>{props.title}</h2>
      <img src='/images/parents-v2/yellow-hearts-doodle-icon.svg' />
    </div>
    <div className='quotes'>

      <div className='desktop'>
        <div className='quotes--track'>
          {props.quotes.map((q, i) => (
            <div className='quote' key={i}>
              <div className='quote--rating'>
                <img src='/images/parents-v2/trustpilot-stars.svg' />
              </div>
              <div className='quote--text'>
                "{q.text}"
              </div>
              <div className='quote--author'>
                <div>{q.author.name}</div>
                <div>{q.author.type}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='mobile'>
        <div className='quotes--track'>
          {[0, 1].map(groupIndex => (
            <div className='quotes--group' key={groupIndex}>
              {props.quotes.map((q, i) => (
                <div className='quote' key={`${groupIndex}-${i}`}>
                  <div className='quote--rating'>
                    <img src='/images/parents-v2/trustpilot-stars.svg' />
                  </div>
                  <div className='quote--text'>
                    "{q.text}"
                  </div>
                  <div className='quote--author'>
                    <div>{q.author.name}</div>
                    <div>{q.author.type}</div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
    <div>
      {props.cta && <div className='cta'>
        <Link to={props.cta.url}>
          <Button theme='primary'>{props.cta.label}</Button>
        </Link>
      </div>}
    </div>
  </Wrapper>
}
